import { render, staticRenderFns } from "./select-guide.vue?vue&type=template&id=b4df5a8a"
import script from "./select-guide.vue?vue&type=script&lang=js"
export * from "./select-guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports